<template>
  <div class="vertical grow gallery-container" style="width: 35vw; height: 100%">
        <div style="margin-top: 20px;">
            <div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td class="title-td" style="width:200px;"><p class="info-field-title">{{ $t('MainAssignee') }}</p></td>
                        <td style="width:400px;" class="info-field-value">
                            <select v-model="ticketInfo.assignedFarmerId" style="width: 100%">
                                <option v-for="n in systemUserNames" :key="n.id" :value="n.id">
                                    {{n.name}}
                                </option>
                            </select>
                        </td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td class="title-td"  style="width:200px;"><p class="info-field-title">{{ $t('Subject') }}</p></td>
                        <td style="width:400px;" class="info-field-value">
                            <textarea v-model="ticketInfo.subject" type="text" :placeholder="$t('Subject')" style="height: 50px; width: 100%"/>
                        </td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td class="title-td" style="width:200px;"><p class="info-field-title">{{ $t('Content') }}</p></td>
                        <td style="width:400px;" class="info-field-value">
                            <textarea v-model="ticketInfo.content" type="text" :placeholder="$t('Content')" style="width: 100%"/>
                        </td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td class="title-td" style="width:200px;"><p class="info-field-title">{{$t('Photos')}}</p></td>
                        <td style="width:400px;" class="info-field-value">
                            <div class="thumbnails horizontal" style="padding-bottom: 10px;">
                                <div v-for="(photo, index) in photos" :key="index">
                                    <div class="thumbnail-container">
                                        <img class="delete-image" style="cursor: default;" src="~@/assets/img/Visits/Delete.svg" @click="deletePhoto(index)">
                                        <img :src="photo.url" class="thumbnail"/>
                                    </div>
                                </div>
                            </div>
                            <input type="file" id="problemPhotoId" name="problemPhoto" accept="image/*" @change.prevent="addPhoto" multiple>
                        </td>
                    </tr>
                </div>
                <div style="justify-content: center; margin-bottom: 10px;" class="horizontal">
                    <div class="error" v-if="error != ''">{{ error }}</div>
                </div>
            </div>
        </div>
        <div style="align-self: center; margin-bottom: 20px;">
            <Button :title="$t('Save')" buttonClass='save-button semi-bold' style="width: 300px; align-self: center;" @onClick="save"></Button>
        </div>
    </div>
</template>

<script>

import { getSystemUsersNames, postNewTicket } from '@api';
import DatePicker from 'vue2-datepicker';
import Button from '../../Button.vue';

export default {
    props: {
        systemId: {
            type: String,
            required: true
        }
    },
    components: {
        DatePicker,
        Button
    },
    data() {
        return {
            ticketInfo: {
                systemId: '',
                subject: '',
                content: '',
                assignedFarmerId: ''
            },
            error: '',
            systemUserNames: [],
            photos: [],
            activePhotoIndex: 0
        }
    },
    methods: {
        async getData() {
            this.systemUserNames = await getSystemUsersNames(this.systemId)

            if(this.systemUserNames.length == 1) {
                this.ticketInfo.assignedFarmerId = this.systemUserNames[0].id
            }
        },
        async save() {
            this.checkDataCorrectness()

            if(this.error != "") {
                return;
            }

            this.ticketInfo.systemId = this.systemId;
            var toSend = Object.assign({}, this.ticketInfo)
            var form = new FormData()
            var keys = Object.keys(toSend)
            for(let i = 0; i < keys.length; i++){
                form.append(keys[i], toSend[keys[i]])
            }

            var photosSrc = this.photos.map(x => x.src)
            for(let i = 0; i < photosSrc.length; i++) {
                form.append("resources", photosSrc[i])
            }
            try {
                await postNewTicket(form)
            } catch(e) {
                this.error = e;
                return;
            }
            this.$emit('saved')
        },
        checkDataCorrectness() {
            this.error = ""

            if(this.ticketInfo.assignedFarmerId == '') {
                this.error = this.$i18n.t("AssigneeNotSelected");
                return;
            }

            if(this.ticketInfo.subject == ''){
                this.error = this.$i18n.t("SubjectNotFilled");
                return;
            }

            if(this.ticketInfo.content == '') {
                this.error = this.$i18n.t("ContentNotFilled");
                return;
            }

        },
        sortSystemsByName(a, b){
			return (a.name.localeCompare(b.name, undefined, {
              numeric: true,
              sensitivity: 'base'
            }));
		},
		addPhoto(e){
            for(let i = 0; i < e.target.files.length; i++ ) {
                var photo = URL.createObjectURL(e.target.files[i]);
                this.photos.push({
                    src: e.target.files[i],
                    url: photo
                });
            }
            this.activePhotoIndex = this.photos.length - 1
        },
        deletePhoto(index) {
            this.activePhotoIndex = this.activePhotoIndex == index ? index > 1 ? index - 1 : 0 : this.activePhotoIndex;
            this.photos.splice(index, 1);
        },
    },
    async mounted() {
        this.getData()
    }
}
</script>

<style scoped>
.gallery-container {
    background: #F9F9F9;
    box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);
    border-radius: 5px;
}

.section-title {
    font-weight: bold;
    text-align: center;
}

.info-field {
    border-bottom: 1px solid #E9E9E9;
    margin-bottom: 12px;
    margin-top: 12px;
    justify-content: center;
}

.info-field-title {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
    margin: 0;
}

.info-field-row {
    align-self: center;
    width: 80%;
    margin: 0;
    padding-bottom: 5px;
}

.section-title {
    font-weight: bold;
}

select {
    width: 210px;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}

textarea {
    height: 200px;
    max-height: 300px;
    width: 210px;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}

.info-field-row > td {
    vertical-align: middle;
}

.error {
    font-size: 14px;
}
</style>

<style scoped>
.info-field-value {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Systems/Tickets/TicketModal.vue